import React, { FC, useEffect, useState } from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import { GoalStore } from "../../../../../../cog/keystone/goals";
import {useMainContext} from "../../../../../../contexts/MainContext";
import currencySwitcher from "../../../../../../utils/currencySwitcher";

interface GoalValueComponentProps {
  goalID: string
}

const GoalValueComponent: FC<GoalValueComponentProps> = ({goalID}) => {
  const mainCtx = useMainContext()
  let formatter = Intl.NumberFormat('en', {notation: 'compact'});
  const [loading, setLoading] = useState<boolean>(false)
  const [value, setValue] = useState<number>(0)

  const getGoalValue = async () => {
    setLoading(true)

    const response = await GoalStore.CalculateGoalValue({goalID: goalID, clientName: mainCtx.activeOrganization.name})
    if (response && response.value) {
      return response.value
    }
  }

  useEffect(() => {
    let isMounted = true;
    getGoalValue().then((r) => {
      if (isMounted && r) {
        setValue(Object.values(r)[0])
        setLoading(false)
      }
    })

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Box
      sx={{
        justifyContent: 'center',
        display: 'flex',
        width: '100%',
        position: 'relative',
        alignItems: 'center'
      }}
    >
      {!loading ? <Typography>{currencySwitcher(mainCtx.activeOrganization.name) + " " + formatter.format(value)}</Typography> : <Skeleton sx={{ width: "35vw" }} />}
    </Box>
  );
}

export default GoalValueComponent;